import {
	Accordion,
	ComplaintsIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";

export function ComplaintsFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, facets } = useFiltersContext();
	const value = filters.complaints ?? [];
	const facetCounts = facets?.complaints;

	const getCount = (complaint: string): number | undefined => {
		if (!facetCounts?.length) return undefined;
		return facetCounts.find((f) => f.value === complaint)?.count ?? 0;
	};

	const sortedComplaints = useMemo(() => {
		// @ts-ignore: dynamic key generation
		const translate = (key: string) => t(`filters.complaints.${key}`) as string;
		return [...config.complaints].sort((a, b) => {
			const translatedA = translate(a);
			const translatedB = translate(b);
			return translatedA.localeCompare(translatedB);
		});
	}, [config.complaints, t]);

	return (
		<Accordion.Item
			value="complaints"
			variant="filter"
			data-testid="complaints-filter"
		>
			<Accordion.Trigger
				variant="filter"
				data-testid="complaints-filter-trigger"
			>
				<FilterHeader
					title={t("filters.complaints")}
					value={Number(value?.length)}
					icon={<ComplaintsIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2"
					value={value}
					onValueChange={(val) => onFilterChange("complaints", val)}
				>
					{sortedComplaints.map((complaint) => {
						const isSelected = value.includes(complaint);
						const count = getCount(complaint);
						const isDisabled = count === 0 && !isSelected;
						return (
							<ToggleGroup.Item
								key={complaint}
								value={complaint}
								className="capitalize"
								disabled={isDisabled}
							>
								{/* @ts-ignore: dynamic key generation */}
								{t(`filters.complaints.${complaint}`)}
							</ToggleGroup.Item>
						);
					})}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
